module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG381eb50fa128c160ccf6417479d3cef7.381eb50f.png";